<template>
  <div>
    <vue-topprogress ref="loadingProgress"></vue-topprogress>
    <div v-if="!loading">
      <h1 class="display-4 font-weight-lighter">
        Configuration Documents
      </h1>
      <br />
      <div v-if="document_folder && editable">
        <upload-button
            :folder_id="document_folder.id"
        ></upload-button>
        <br />
      </div>
      <div v-if="!error">

        <b-table
          v-if="documents"
          hover
          :items="documents"
          :fields="fields"
        >
          <template v-slot:cell(name)="data">
            <span>{{ data.item.name }}</span>
          </template>
          <template v-slot:cell(preview)="data">
            <document-preview
              v-if="data.item"
              :document="data.item"
              :cache="false"
              :width="100"
            ></document-preview>
          </template>
          <template v-slot:cell(document)="data">
            <upload-button
              :folder_id="document_folder.id"
              :pre_loaded_document="data.item"
              :editable="true"
              :deletable="false"
              :manage_meta="editable"
              @onUploaded="(document) => {data.item = document}"
              @onDocumentChange="(document) => {data.item = document}"
            ></upload-button>
          </template>
        </b-table>

      </div>
      <b-alert v-else show>
        <div v-if="!document_folder">Configuration folder has not been created yet. <span class="btn-link" @click="createFolder">Click here to create.</span></div>
        <div v-else>{{error}}</div>
      </b-alert>
    </div>
  </div>
</template>

<script>

  import Document from "../../models/Document";
  import DocumentPreview from "../../components/documents/DocumentPreview";
  import UploadButton from "../../components/documents/UploadButton";
  import DocumentFolder from "../../models/DocumentFolder";

  export default {
    name: 'ConfigDocumentManage',
    components: {UploadButton, DocumentPreview},
    props: ['editable'],
    data() {
      return {
        loading: true,
        error: null,
        document_folder: null,
        documents: null,
        src: null,
        fields: ['name', 'preview', 'document']
      };
    },
    methods: {
      init() {
        this.$refs.loadingProgress.start();
        this.loading = true;
        return this.fetch().then(() => {
          return this.populate().then(() => {
            this.error = null;
            this.$refs.loadingProgress.done();
            this.loading = false;
          }, this.defaultError);
        }, this.defaultError);
      },
      fetch() {
        return new Promise((resolve, reject) => {
          return DocumentFolder.api().fetch({name: 'Configuration'}).then((results) => {
            if(!results.entities.document_folders) {
              return reject();
            }
            this.document_folder = results.entities.document_folders[0] || null;
            if(this.document_folder) {
              return Document.api().fetch({document_folder_id: this.document_folder.id}).then((results) => {
                if(results.entities.documents) {
                  this.documents = results.entities.documents;
                  return resolve(this.documents);
                } else {
                  return reject();
                }
              }, reject);
            } else {
              return reject();
            }
          }, reject);
        });
      },
      populate() {
        return new Promise((resolve) => {
          return resolve();
        });
      },
      defaultError() {
        this.$refs.loadingProgress.done();
        this.loading = false;
        this.error = 'Configuration documents are not available at this moment, please try again later.';
      },
      onUploaded(d_old, d_index, d_new) {
        d_old = d_new;
      },
      createFolder() {
        DocumentFolder.api().create({name: 'Configuration', icon: 'cogs', private: 1}).then(() => {
          this.init();
        }, this.defaultError);
      }
    },
    mounted() {
      this.init();
    }
  }
</script>
